import { AxiosError } from "axios";

import { api } from "@/lib/axios";

interface UserUpdateData {
	email: string;
	name: string;
	nickname: string;
	phone: string;
	zipcode: string;
	street: string;
	number: string;
	district: string;
	complement: string | null;
	city: string;
	state: string;
}

export async function updateProfile(
	data: Partial<UserUpdateData>,
	id: string,
): Promise<
	| {
			status: "success";
	  }
	| { status: "error"; errors: { [key: string]: string } }
> {
	try {
		await api.post(`/user/${id}`, data);

		return {
			status: "success",
		};
	} catch (error: unknown) {
		const axiosError = error as AxiosError<{
			errors: { [key: string]: string };
		}>;

		if (axiosError.response?.status === 422) {
			return {
				status: "error",
				errors: axiosError.response.data.errors,
			};
		}

		return {
			status: "error",
			errors: {
				unknown: "Erro desconhecido. Tente novamente mais tarde.",
			},
		};
	}
}
